/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandResponse,
    BrandResponseFromJSON,
    BrandResponseFromJSONTyped,
    BrandResponseToJSON,
    MarketResponse,
    MarketResponseFromJSON,
    MarketResponseFromJSONTyped,
    MarketResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface BrandAndMarketResponse
 */
export interface BrandAndMarketResponse {
    /**
     * 
     * @type {BrandResponse}
     * @memberof BrandAndMarketResponse
     */
    brand?: BrandResponse;
    /**
     * 
     * @type {MarketResponse}
     * @memberof BrandAndMarketResponse
     */
    market?: MarketResponse;
}

export function BrandAndMarketResponseFromJSON(json: any): BrandAndMarketResponse {
    return BrandAndMarketResponseFromJSONTyped(json, false);
}

export function BrandAndMarketResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandAndMarketResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brand': !exists(json, 'brand') ? undefined : BrandResponseFromJSON(json['brand']),
        'market': !exists(json, 'market') ? undefined : MarketResponseFromJSON(json['market']),
    };
}

export function BrandAndMarketResponseToJSON(value?: BrandAndMarketResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brand': BrandResponseToJSON(value.brand),
        'market': MarketResponseToJSON(value.market),
    };
}


